import { useEffect, useState } from "react";

const MultipleListingInput = ({ id, setSelectedItems, selectedItems }) => {
  const [price, setPrice] = useState("");
  const displayValue = price ? `$${price}` : "";

  const handleChange = (e) => {
    let value = e.target.value;

    // Убираем всё, кроме цифр и точки (как у вас)
    value = value.replace(/[^0-9.]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    if (value.includes(".")) {
      const [integer, decimal] = value.split(".");
      value = integer + "." + decimal.slice(0, 2);
    }

    if (value.startsWith(".")) {
      value = "0" + value;
    }

    if (value && !value.startsWith("0.")) {
      value = value.replace(/^0+/, "") || "0";
      if (value === ".") value = "0.";
    }

    setPrice(value);

    const isEmptyOrZero =
      value === "" ||
      value === "0" ||
      value === "0." ||
      value === "0.0" ||
      value === "0.00";

    setSelectedItems((prev) => {
      if (isEmptyOrZero) {
        return prev.filter((item) => item.id !== id);
      }

      const exists = prev.some((item) => item.id === id);
      if (exists) {
        return prev.map((item) =>
          item.id === id ? { ...item, price: value } : item
        );
      } else {
        return [...prev, { id, price: value }];
      }
    });
  };

  // 🔹 НОВЫЙ: обработчик потери фокуса
  const handleBlur = () => {
    if (price.trim() === "") {
      setPrice("");
      return;
    }

    // Преобразуем в число
    const num = parseFloat(price);
    if (isNaN(num)) {
      setPrice("");
      return;
    }

    // Форматируем до 2 знаков — возвращаем строку!
    const formatted = num.toFixed(2);
    setPrice(formatted);

    // Также обновляем selectedItems с отформатированным значением
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === id);
      if (exists) {
        return prev.map((item) =>
          item.id === id ? { ...item, price: formatted } : item
        );
      } else {
        return [...prev, { id, price: formatted }];
      }
    });
  };

  const handleClear = () => {
    setPrice("");
    setSelectedItems((prev) => prev.filter((item) => item.id !== id));
  };

  useEffect(() => {
    const currentItem = selectedItems.find((item) => item.id === id);
    if (currentItem) {
      setPrice(currentItem.price);
    } else {
      setPrice("");
    }
  }, [selectedItems, id]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input
        type="text"
        placeholder="Listing price"
        value={displayValue}
        onClick={(e) => e.stopPropagation()}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{ flex: 1 }}
      />
      {price && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleClear();
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#ffffff"
              strokeWidth="1.4"
              strokeLinecap="square"
            ></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default MultipleListingInput;

// import { useEffect, useState } from "react";

// const MultipleListingInput = ({ id, setSelectedItems, selectedItems }) => {
//   const [price, setPrice] = useState("");
//   const displayValue = price ? `$${price}` : "";

//   const handleChange = (e) => {
//     let value = e.target.value;


//     value = value.replace(/[^0-9.]/g, "");


//     const parts = value.split(".");
//     if (parts.length > 2) {
//       value = parts[0] + "." + parts.slice(1).join("");
//     }


//     if (value.includes(".")) {
//       const [integer, decimal] = value.split(".");
//       value = integer + "." + decimal.slice(0, 2);
//     }


//     if (value.startsWith(".")) {
//       value = "0" + value;
//     }


//     if (value && !value.startsWith("0.")) {
//       value = value.replace(/^0+/, "") || "0";
//       if (value === ".") value = "0.";
//     }

//     setPrice(value);

//     const numericValue = value;
//     const isEmptyOrZero =
//       numericValue === "" ||
//       numericValue === "0" ||
//       numericValue === "0." ||
//       numericValue === "0.0" ||
//       numericValue === "0.00";

//     setSelectedItems((prev) => {
//       if (isEmptyOrZero) {
//         return prev.filter((item) => item.id !== id);
//       }

//       const exists = prev.some((item) => item.id === id);
//       if (exists) {
//         return prev.map((item) =>
//           item.id === id ? { ...item, price: numericValue } : item
//         );
//       } else {
//         return [...prev, { id, price: numericValue }];
//       }
//     });
//   };

//   const handleClear = () => {
//     setPrice("");
//     setSelectedItems((prev) => prev.filter((item) => item.id !== id));
//   };

//   useEffect(() => {
//     const currentItem = selectedItems.find((item) => item.id === id);
//     if (currentItem) {
//       setPrice(currentItem.price);
//     } else {
//       setPrice("");
//     }
//   }, [selectedItems, id]);

//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//       <input
//         type="text"
//         placeholder="Listing price"
//         value={displayValue}
//         onClick={(e) => e.stopPropagation()}
//         onChange={handleChange}
//         style={{ flex: 1 }}
//       />
//       {price && (
//         <button
//           type="button"
//           onClick={(e) => {
//             e.stopPropagation();
//             handleClear();
//           }}
//         >
//           <svg
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
//               stroke="#ffffff"
//               strokeWidth="1.4"
//               strokeLinecap="square"
//             ></path>
//           </svg>
//         </button>
//       )}
//     </div>
//   );
// };

// export default MultipleListingInput;
